import {
  GoalRenderFragment,
  ObservationRenderFragment,
} from '@eluve/fhir-renderer';
import { graphql } from '@eluve/graphql-fhir';

/**
 * FHIR Patient lookup by Eluve patient identifier (the Hasura patient id the
 * profile route carries). Mirrors the profile shell's provisioning query but
 * only needs the id — the goals card keys everything off the FHIR id.
 */
export const FHIR_PATIENT_ID_QUERY = graphql(`
  query FhirGoalsPatientId($identifier: String!) {
    PatientList(identifier: $identifier, _count: 1) {
      id
    }
  }
`);

/**
 * The patient's goals, one bounded page per explicit loadMore (never
 * fetch-all). Sorted by `-_lastUpdated`: Goal's clinical-time search params
 * (`start-date`, `target-date`) are absent on agent drafts (which only carry
 * `statusDate`, unsearchable in R4), so last-write order is the one sort
 * that keeps fresh drafts on the first page; the derivations re-sort by
 * clinical time. Selections come from the entity's render fragment so the
 * renderer's display contract stays the single source.
 */
export const PATIENT_GOALS_QUERY = graphql(
  `
    query FhirPatientGoals($patientRef: String!, $offset: Int) {
      GoalConnection(
        patient: $patientRef
        _count: 100
        _offset: $offset
        _sort: "-_lastUpdated"
      ) {
        count
        offset
        edges {
          resource {
            ...GoalRender
          }
        }
      }
    }
  `,
  [GoalRenderFragment],
);

/**
 * The observation window the goal rows resolve their tracked series from
 * (sparkline + "now" value). Same shape as the Observations card's read so
 * the two sections tell one story; a goal whose addressed observation falls
 * outside the loaded window simply renders without a trend — never a
 * fetch-all.
 */
export const TRACKED_OBSERVATIONS_QUERY = graphql(
  `
    query FhirGoalTrackedObservations($patientRef: String!, $offset: Int) {
      ObservationConnection(
        patient: $patientRef
        _count: 100
        _offset: $offset
        _sort: "-date"
      ) {
        count
        offset
        edges {
          resource {
            ...ObservationRender
          }
        }
      }
    }
  `,
  [ObservationRenderFragment],
);
